import * as React from 'react';
import { cn } from 'lib/utils';

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  fullWidth?: boolean;
}

const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, fullWidth = false, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'mx-auto px-4 sm:px-6 lg:px-8',
          fullWidth ? 'w-full' : 'max-w-7xl',
          className
        )}
        {...props}
      />
    );
  }
);
Container.displayName = 'Container';

export { Container };
